import React from 'react';
import PropTypes from 'prop-types';
import { 
  HeroMain,
  MainBox,
  HeroTitle,
  HeroImage,
  HeroSubTitle,
  LogoContainer,
  HeroSubTitleContainer,
  BreadcrumbsMain,
  BreadcrumbsList,
  BreadcrumbsItem,
  PageTitle
} from './index.style'
import RichText from '@components/RichText';
import { GatsbyImage } from 'gatsby-plugin-image';
import Logo from '@svgs/Logo';
import { Heading4Serif } from '@components/TextStyles';
import { colors } from '@styles/vars/colors.style'
import Container from '@components/Container';
import Spacer from '@components/Spacer';
import PageTransitionLink from '@components/PageTransitionLink'

const Hero = props => {
  const { backgroundColor, textColor, name, title, image, pageSeoTitle } = props;

  const background = backgroundColor ? backgroundColor : colors.white;
  const color = textColor ? textColor : colors.charcoal;

  return (
    <HeroMain color={color} background={background}>
      <Container>
        <MainBox>
          <HeroTitle>
            <BreadcrumbsMain aria-label="Breadcrumb">
              <BreadcrumbsList>
                <BreadcrumbsItem>
                  <PageTransitionLink to="" underline={false}>Home</PageTransitionLink>
                </BreadcrumbsItem>
                <BreadcrumbsItem>
                  <PageTransitionLink to={`what-we-do/`} underline={false}>What we do</PageTransitionLink>
                </BreadcrumbsItem>
                <BreadcrumbsItem>
                  <strong>{name}</strong>
                </BreadcrumbsItem>
              </BreadcrumbsList>
            </BreadcrumbsMain>
            <PageTitle>{pageSeoTitle}</PageTitle>
            <RichText className="title" content={title} buildOn/>
          </HeroTitle>
          <HeroImage>
            <Spacer size={[30, 65]}/>
            <GatsbyImage image={image.gatsbyImageData} alt={image.description} height="526" width="526" loading="eager" fetchPriority="high" />
          </HeroImage>
          <HeroSubTitleContainer>
            <HeroSubTitle>
              <LogoContainer><Logo height={30}/></LogoContainer>
              <Heading4Serif as="span">{name}</Heading4Serif>
            </HeroSubTitle>
          </HeroSubTitleContainer>
        </MainBox>
      </Container>
    </HeroMain>
  );
};

Hero.propTypes = {
  image: PropTypes.object,
  title: PropTypes.object,
  backgroundColor: PropTypes.string,
  textColor: PropTypes.string,
  name: PropTypes.string
};

export default Hero;